<template>
   <div>
     <div class="search_unit">
        <div style='display:inline-block;'>
          <el-input placeholder="请输入手机或姓名查询" v-model="keywords" class="input-with-select" @change='getList()'>
                    <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
          </el-input>
        </div>
        <div style='display:inline-block;margin-left:5px;float:right;'>
          <el-button type="primary" icon="el-icon-download" size="small" @click="doDownloadUserList">导出全部数据</el-button>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="id"
        label="ID"
        >
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机"
        >
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        >
      </el-table-column>
      <el-table-column
        label="类型"
      >
        <template slot-scope="scope"> 
            <span v-if="scope.row.type==1">分销商</span><span v-else-if="scope.row.type==2">招商经理</span>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        >
        <template slot-scope="scope"> 
          <el-tag type="success" v-if="scope.row.status==1">有效</el-tag>
          <el-tag type="info" v-else>无效</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间">
        <template slot-scope="scope"> 
           {{scope.row.createtime | timeToDate}}    
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope"> 
             <el-dropdown split-button type="primary" @click='handleEdit(scope.row.id)' @command='(command)=>handleItem(command,scope.row.id)'>
              修改基础信息
              <el-dropdown-menu slot="dropdown">
                <!--<el-dropdown-item command='mcommission' v-if="scope.row.type==2">设置管理佣金</el-dropdown-item>-->
                <el-dropdown-item command='delete'>删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>
   </div> 
</template>

<script>
import {download} from '../../api/index'

export default {
  data(){
     return {
        tableData:[],
        keywords:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        }
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/user/getUserList",{pageinfo:this.pageinfo,keywords:this.keywords}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.userlist
                  this.pageinfo=data.result.info.pageinfo 
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      doDownloadUserList(){
        download("/download/downloadUserList") 
      },
      handleEdit(userid){
        this.$router.push({name:'addUser',query:{userid:userid}})
      },
      handleItem(command,userid){
        switch(command){
          case 'mcommission':
               this.$router.push({name:'usercommission',query:{userid:userid}}) 
               break;
          case 'delete':
                this.$post("/user/delAccount",{userid:userid}).then((data)=>{
                  if(data.result.success){
                      this.$message({message:data.result.info,type:'success'})
                      setTimeout(()=>{this.getList()},300)
                  }else{
                      this.$message.error(data.result.info)
                  } 
                })
                break;
          default:
                this.$message.error("选项有误");      
        }
      }
  }
}
</script>

<style scoped lang="scss">
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
</style>
